
import { Inject, Injectable } from '@angular/core';
import { ApiCommonService, TimeApiService } from 'cbc-shared-lib';
import { Observable, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';
import { Sgke902aRequest, Sgke902aResponse, Sgke902aService } from 'sg-api';
import { FeaturesLibConfig } from '../../../config/features-lib-config';
import { FEATURES_LIB_CONFIG } from '../../../config/features-lib-config.token';

@Injectable({
  providedIn: 'root'
})
export class UsedSgke902aService {

  constructor(
    public service: Sgke902aService,
    private apiCommonService: ApiCommonService,
    private timeApiService: TimeApiService,
    @Inject(FEATURES_LIB_CONFIG) private featuresLibcComfig: FeaturesLibConfig
  ) { }

  /**
   * SGKE902A_API仕様書_供給停止・再開延期登録API呼び出し
   * @param {Sgke902aRequest} request 
   * @returns {Observable<Sgke902aResponse>}
   * @memberof UsedSgke902aService
   */
  public doSgke902a(request: Sgke902aRequest): Observable<Sgke902aResponse> {
    //日付のフォーマットをYYMMDDに変更
    this.apiCommonService.convertElementInObject(request, Object.prototype.toString.call(new Date()), this.timeApiService.convertDateToString);
    return this.service.SGKE902APost(this.apiCommonService.setRequestCommon(<any>request), 'response')
      .pipe(
        map(
          response => {
            // エラーが設定されていないかチェックする
            this.apiCommonService.checkError(response);
            return response.body;
          }),
        timeout(Number(this.featuresLibcComfig.httpTimeout)),
        catchError((err) => {
          this.apiCommonService.dispErrorMessage(err, 'bill', 'SGKE902A');
          return throwError(err.message);
        })
      );
  }
}
